import React from 'react'

import SearchField from '../searchField.component'
import HeaderBlockContent from './headerBlockContent.component'
import HeaderBackgroundLayout from './headerBackgroundLayout.component'
import { IMedia } from '../../interfaces/media'
import Logo from './logo.component'
import { useAppContext } from '../../context/siteMapContext'
import { WebMenuTypeEnum } from '../../interfaces/webMenu'
import { useRouter } from 'next/router'

interface IHeaderProps {
  sloganTop_HU?: string
  subTitle?: string
  headerImage: IMedia;
}

const Header = ({
  sloganTop_HU = 'Távol a belvárostól, közel egymáshoz.',
  subTitle = 'ÜDVÖZÖLJÜK A XVIII. KERÜLET HONLAPJÁN',
  headerImage
}: IHeaderProps) => {
  const { activePage, highContrastOn } = useAppContext();
  const router = useRouter();

  const navigateToSearchPage = (input: string) => {
    router.replace('search', `kereses?kifejezes=${input}`)
  }

  return (
    <header className='relative flex flex-col bg-top h-home-header 2xl:flex-row 2xl:gap-desktop 2xl:h-home-header-2xl 2xl:justify-between'>
      <Logo />
      <div className={`z-0 absolute w-full h-home-header-assets 2xl:h-home-header-assets-2xl ${highContrastOn ? 'bg-black border-b-[6px]' : ''}`}>
        {!highContrastOn && <HeaderBackgroundLayout headerImage={headerImage}>
          <div className='absolute inset-y-0 right-0 z-0 header-block-bg 2xl:header-block-bg-desktop bg-default-header-block-bg-color opacity-95 bg-cover bg-no-repeat w-9/12 2xl:w-3/5' />
        </HeaderBackgroundLayout>
        }
      </div>
      <div className='z-1 flex justify-end w-full py-6 px-mobile 2xl:w-4/12 order-2 2xl:order-1'>
        <div className='flex w-full 2xl:w-9/12 h-full items-center'>
          {activePage?.type !== WebMenuTypeEnum.SEARCH && <SearchField searchPlaceholder={'Keresőszó vagy kifejezés...'} value='' search={navigateToSearchPage} />}
        </div>
      </div>
      <div className='z-1 w-full 2xl:w-3/12 order-1 2xl:order-2'>
        <HeaderBlockContent slogan={sloganTop_HU} subTitle={subTitle} />
      </div>
    </header>
  )
}

export default Header
